import React from "react";

function ImageCenter({ image, background }) {
  return (
    <div
      style={{
        position: "relative",
        width: "100vw",
        height: "100vh",
        background: `url(${background}) center center / cover no-repeat`,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {/* Centered image, slightly above center */}
      <div
        style={{
          background: "#fff",
          borderRadius: 2,
          boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
          width: "80%",
          maxWidth: 1200,
          minHeight: 180,
          margin: "40px 0",
          padding: "60px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <img
          src={image}
          alt="How It Works Illustration"
          style={{ width: "100%", height: "100%", objectFit: "contain" }}
        />
      </div>
    </div>
  );
}

export default ImageCenter;
